import _jsx from "@babel/runtime/helpers/jsx";

var _FormattedMessage, _AdvertiserNote;

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AdvertiserNote from 'components/AdvertiserNote';
import { Wrapper, UpdateText } from './styles';
var UpdatedInfo = /*#__PURE__*/memo(function (_ref) {
  var updated = _ref.updated,
      isCompanyPage = _ref.isCompanyPage;
  return /*#__PURE__*/_jsx(Wrapper, {
    isCompanyPage: isCompanyPage
  }, void 0, /*#__PURE__*/_jsx(UpdateText, {}, void 0, _FormattedMessage || (_FormattedMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    id: "header.updated"
  })), "\xA0", updated), _AdvertiserNote || (_AdvertiserNote = /*#__PURE__*/_jsx(AdvertiserNote, {})));
});
UpdatedInfo.propTypes = {
  updated: PropTypes.string,
  isCompanyPage: PropTypes.bool
};
UpdatedInfo.defaultProps = {
  updated: '',
  isCompanyPage: false
};
export default UpdatedInfo;